import { LabelList, Pie, PieChart } from "recharts"
import {
    Card,
    CardContent,
    CardHeader,
    CardTitle,
} from "@/components/ui/card"
import {
    ChartConfig,
    ChartContainer,
    ChartTooltip,
    ChartTooltipContent,
} from "@/components/ui/chart"
import { useEffect, useState } from "react"
import axiosInstance from "@/utils/axiosInstance"

const chartConfig = {
    status: {
        label: "Status",
        color: "hsl(var(--chart-2))",
    },
    count: {
        label: "Count",
        color: "var(--color-chart-dark-green)",
    }
} satisfies ChartConfig

const DriverAvailabilityChart = ({ range }: { range: { startDate: Date, endDate: Date } }) => {

    const [chartData, setChartData] = useState([])

    const STATUS_COLORS: any = {
        AVAILABLE: "var(--color-chart-dark-green)",
        OFFLINE: "#68fc88",
        BUSY: "var(--color-busy)",
    };

    useEffect(() => {
        const fetchData = async () => {
            try {

                const res = await axiosInstance.get(`/reports/driver-availability`, {
                    params: {
                        startDate: range.startDate.toISOString().split("T")[0],
                        endDate: range.endDate.toISOString().split("T")[0],
                    },
                })

                const transformed = res.data.map((item: any) => ({
                    ...item,
                    fill: STATUS_COLORS[item.status] || "var(--color-default)",
                }));

                setChartData(transformed);

            } catch (error) {
                console.error("Gabim gjatë marrjes së të dhënave:", error)
            }
        }

        fetchData()
    }, [range])

    return (
        <Card className="flex flex-col">
            <CardHeader className="items-center pb-0">
                <CardTitle>Drivers by availability</CardTitle>
            </CardHeader>
            <CardContent className="flex-1 pb-0">
                <ChartContainer
                    config={chartConfig}
                    className="mx-auto aspect-square max-h-[250px] [&_.recharts-text]:fill-background"
                >
                    <PieChart>
                        <ChartTooltip
                            content={<ChartTooltipContent nameKey="count" hideLabel />}
                        />
                        <Pie data={chartData} dataKey="count">
                            <LabelList
                                dataKey="status"
                                className="fill-background"
                                stroke="none"
                                fontSize={12}
                            />
                        </Pie>
                    </PieChart>
                </ChartContainer>
            </CardContent>
        </Card>
    )

}

export default DriverAvailabilityChart;